if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  //HTML References
  let burger_menu = document.querySelector(".js-burger-menu");
  const header_logo = document.querySelector(".header svg");
  const dark_logo = document.querySelector(".logo-dark");
  const navigation = document.querySelector(".js-navigation");
  const burger_label = document.querySelector(".js-burger-menu .label");
  const header_social = document.querySelector(".header .social-media");
  const header_book = document.querySelector(".header-left .btn");
  let header = document.getElementById("header");

  // const searched_ids = ["gallery", "attractions", "sitemap"];


  //SLIDERS CONFIGURATIONS
  $(".sym-slides").slick({
    accessibility: true,
    infinite: false,
  });

  $(".accommodations-slider").slick({
    accessibility: true,
    infinite: false,
  });

  $(".slider-block-slider").slick({
    accessibility: false,
    arrows: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  $(".reviews-slider").slick({
    accessibility: false,
    arrows: true,
    fade: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  $(".slingle-slider-start").slick({
    accessibility: false,
    arrows: true,
    fade: true,
    dots: false,
    adaptiveHeight: true,
  });

  $(".slider-awards-start").slick({
    accessibility: false,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });

  $(".slider-large-start").slick({
    accessibility: true,
    arrows: true,
    dots: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true
        }
      },
    ]
  });

  $(".slider-single-quad").slick({
    accessibility: true,
    arrows: true,
    dots: false,
    fade: true,
    slidesToScroll: 1,
  });

  if(document.querySelector('.gallery-slider')) {
    $(".gallery-slider").slick({
      accessibility: true,
      arrows: true,
      dots: false,
      slidesToScroll: 1,
      fade: true,
    });
  }
  //END SLIDERS CONFIGURATIONS

  //HEADER MENU Functionality
  const changeLogo_on_menu_open = () => {
    let header_logo = document.querySelector('.header__logo img')
    let header_active = header.classList.contains('down') || header.classList.contains('up')


      if(navigation.classList.contains('active') && !header_active){

        header_logo.setAttribute('src', '/assets/svg/logo.svg');

      } else if(!navigation.classList.contains('active') && !header_active){

        header_logo.setAttribute('src', '/assets/svg/logo.svg');

      } else if(navigation.classList.contains('active') && header_active){

        header_logo.setAttribute('src', '/assets/svg/logo.svg');

      } else if(!navigation.classList.contains('active') && header_active) {

        header_logo.setAttribute('src', '/assets/svg/TheRockley-Green-Logo.svg');

      }

  }


  const openMenu = () => {
    navigation.classList.toggle("active");
    burger_menu.classList.toggle("active");
    header_social ? header_social.classList.toggle("active") : null;
    header_book.classList.toggle("active");
    header.classList.toggle('active')

    changeLogo_on_menu_open();

    //Change menu label
    burger_menu.classList.contains("active")
      ? (burger_label.innerText = "close")
      : (burger_label.innerText = "menu");
  };


  if (burger_menu) {
    burger_menu.addEventListener("click", () => {
      openMenu();

    });
  }

  if(document.querySelector('.js-mobile-burger')) {
    let burger_mobile = document.querySelector('.js-mobile-burger');

    burger_mobile.addEventListener('click', () => {
      openMenu();
      burger_mobile.classList.toggle('active')
    })
  }
  //END HEADER MENU Functionality

  //Gallery Load Delay
  //This function slows down a little the loading of the gallery images on the screen through classes
  if(document.querySelector('#myGallery')) {
    let gallery = document.querySelector('#myGallery');
    gallery.classList.add('hidde')

    window.addEventListener('load', () => {
      setTimeout( () => {
        gallery.classList.remove('hidde')
       }, 1000)
    })
  }
  //END Gallery Load Delay

  //START FAQs
      //FAQ
    setTimeout(function(){
      $('.tab-label').each(function(){
          let thisHeightTap = $(this).height() + 44;
          let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
          $(this).parent().animate({height: thisHeightTap + 'px'},400);
          if($(this).hasClass('open')){
              $(this).parent().animate({height: thisHeight + 'px'},400);
          }
      });
      $('.learn-more-btn').append('<div class="arrow"></div>');
  }, 400);

  $('.tab-label').click(function(){
      let currentclick = $(this);
      let thisHeightTap = $(this).height() + 44;

      let slideIndex = $(this).data('artwork');
      $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

      if(!currentclick.hasClass('open')){
          $('.tab-label').each(function(){
              if($(this) !== currentclick ){
                  if($(this).hasClass('open')){
                      let thisHeight = $(this).height() + 44;
                      $(this).removeClass('open');
                      $(this).parent().animate({height: thisHeight + 'px'},400);
                  }
              }
          });
          currentclick.addClass('open');
          let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
          $(this).parent().animate({height: thisHeight + 'px'},400);
      } else {
          currentclick.removeClass('open');
          currentclick.parent().animate({height: thisHeightTap + 'px'},400);
      }
  });

  $('[data-fancybox]').fancybox({
      loop : true,
      backFocus: false,
      autoFocus: false,
  });

  $("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a.fancybox))").click(function(e){
      e.preventDefault();
      let strAncla = $(this).prop('hash').substr(1);
      animateto(strAncla);
  });

  let screenHeight = $(window).height();
  $('#home .top-img figure, #home .top-img video').css("height", screenHeight);

  $(window).resize(function(){
      screenHeight = $(window).height();
      $('#home .top-img figure, #home .top-img video').css("height", screenHeight);
  });

  $('a.fancybox').click(function(e){
      e.preventDefault();
      let anchor = $(this).prop('hash');
      $.fancybox.open($(anchor));
  });


  // accordion filter


    const acc_btns = document.querySelectorAll('.accordion__button');
    const acc_items = document.querySelectorAll('.accordion__item');
    if(acc_btns){
        for(let i = 0; i < acc_btns.length; i++){
            acc_btns[i].addEventListener('click', function(){
                if(this.closest('.accordion__item').classList.contains('active')){
                    this.closest('.accordion__item').classList.remove('active');
                }else{
                    for(let a = 0; a < acc_items.length; a++){
                        acc_items[a].classList.remove('active');
                    }
                    this.closest('.accordion__item').classList.add('active');
                }
            })
        } 
    }

    if($('.accordion__filter').length > 0){
        $('.accordion__filter ul li').click(function(){
            const thisTag = $(this).attr('data-tag');
            if(thisTag != 'all'){
                $('.accordion__container .accordion__item').hide();
                $('.accordion__container .'+thisTag).fadeIn();
                $('.accordion__filter ul li').removeClass('active');
                $(this).addClass('active');
            }else{
                $('.accordion__container .accordion__item').fadeIn();
                $('.accordion__filter ul li').removeClass('active');
                $(this).addClass('active');
            }
        });
    }

    if(document.querySelector('.accordion__filter')){
        const filter_tab = document.querySelectorAll('.accordion__filter ul li'); filter_tab[filter_tab.length - 1].click();
    }
    
    if($('.accordion__filter-mobile').length > 0){
        $('#filter-tabs-accordion').on('change', function () {
            const thisTag = $(this).val();
            if(thisTag != 'all'){
                $('.accordion__container .accordion__item').hide();
                $('.accordion__container .'+thisTag).fadeIn();
            }else{
                $('.accordion__container .accordion__item').fadeIn();
            }
        });
    }

  if ($('#filter-tabs-accordion').length > 0) {
    $('#filter-tabs-accordion').val('all').trigger('change');
  }

  //END FAQs

  //Anchor Functionality
  const CURRENT_URL = window.location,
        { search }  = CURRENT_URL; //Get search attribute from object

  if( search ) {
    let searched_id = getSearchedId( search );
    let searched_element = document.querySelector(`${ searched_id }`);
    let position_y = searched_element.getBoundingClientRect().top;

    window.scroll({
      top: position_y - 125,
      behavior: 'smooth'
    })

    function getSearchedId( search ) {
      const params = search.includes('id=')
                        ? search.split('id=')
                        : null;
      let needed_id = params[1];

      return `#${needed_id}`;
    }
  }
  //End Anchor functionality


  //Add HTML In Form submit button
  const AddLineMask = (button) => {
    let line = document.createElement('div');
    line.classList.add('line');
    button.insertAdjacentElement('beforeend', line);
  }

  if(document.querySelector('.signup-btn ')) {
    let button = document.querySelector('.signup-btn ');
    AddLineMask( button );
  }

  if(document.querySelector('.form-module__submit button[type="submit"]')) {
    let results   = document.querySelectorAll('.form-module__submit button[type="submit"]');
    results       = [ ...results ];

    results.forEach( ( button ) => {
      AddLineMask( button )
    })
  }


})();
